export default __webpack_public_path__ + "static/media/3dmodelOpacity_side.c4181a7a.png";